module.exports = __webpack_public_path__ + "img/rarity-used-car-guide.aadf1e5f.jpg";